export enum Permission {
  SeoView = 'seo.view',
  SeoModify = 'seo.modify',
  SeoMarketplaceView = 'seo_marketplace.view',
  SeoMarketplaceModify = 'seo_marketplace.modify',
}
